export default __webpack_public_path__ + "static/media/errorCheck.bcd03892.svg";